import { IconButton, IconButtonProps, TrashOutline } from '@bonusly/design-system';

export const DeleteIconButton = (props: Omit<IconButtonProps, 'icon'>) => {
	return (
		<IconButton colorScheme="secondary" backgroundColor="secondary.bgAlpha" variant="ghost" borderRadius="full" icon={<TrashOutline size="sm" />} {...props} />
	);
};
